function datatables_filters_hide(){
    $(".dataTables_wrapper thead tr th" ).each(function( index ) {
        let test = $(this).css('display');
        $('.dataTables_wrapper thead tr td:eq('+index+')').css('display',test);
    });
}

// modal
function modalBoxButtons(buttons) {

    buttons['ok'] = '<button type="button" class="button-escape btn btn-default btn-sm btn-success" data-dismiss="modal"> Yes </button>';
    buttons['cancel'] = '<button type="button" class="button-escape btn btn-default btn-sm btn-danger" data-dismiss="modal"> No </button>';

    return buttons['ok'];
}
//

function modalBox(title, message, buttons, opts) {

    var idDlg = 'main-modal';
    var header = true;
    buttons = buttons || ['ok'];


    var buttonsHtml = modalBoxButtons(buttons);
    var html = '<div class="modal fade" id="' + idDlg + '"><div class="modal-dialog"><div class="modal-content">';
    if (header) {
        html += '<div class="modal-header"><div class="modal-title">' + title + '</div><button type="button" class="close" data-dismiss="modal">&times;</button></div>';
    }
    html += '<div class="modal-body">' + message + '</div>' +
        '<div class="modal-footer">' + buttonsHtml + '</div>';
    html += '</div></div></div>';


    $('.app-body').append(html)
        .off('hidden.bs.modal').on('hidden.bs.modal', '.modal', function () {
            $(this).remove();
        }).off('shown.bs.modal').on('shown.bs.modal', function () {
            var selector = $('#' + idDlg).find('.button-escape').eq(0);
        });

    $('#' + idDlg).modal({ backdrop: "static", keyboard: true });

}

function confirmBox(message, callback, opts) {
    opts = opts || {};

    var defaultButton = opts['default'] || 'yes';
    var buttonsEscape = { 'no': '', 'yes': '' };

    if (defaultButton == 'yes') {
        buttonsEscape['yes'] = 'button-escape ';
    } else if (defaultButton == 'no') {
        buttonsEscape['no'] = 'button-escape ';
    }

    var title = '';
    var idDlg = 'main-modal';

    var buttons = [];
    buttons['yes'] = '<button type="button" class="' + buttonsEscape['yes'] + 'button-action-yes btn btn-default btn-sm btn-success" data-dismiss="modal" title="Ok"> Yes <i class="fa fa-check" style="width:30px;"></i></button>';
    buttons['no'] = '<button type="button" class="' + buttonsEscape['no'] + 'button-action-no btn btn-default btn-sm btn-danger" data-dismiss="modal" title="Cancel"> No <i class="fa fa-times" style="width:30px;"></i></button>';
    buttons['space'] = '<span style="margin-left:4px"></span>';

    var buttonsHtml = buttons['yes'] + buttons['space'] + buttons['no'];

    var html = '<div class="modal fade" id="' + idDlg + '"><div class="modal-dialog"><div class="modal-content">';
    html += '<div class="modal-header"><button type="button" class="close" data-dismiss="modal" title="Close">&times;</button></div>';
    html += '<div class="modal-body">' + message + '</div>' + '<div class="modal-footer">' + buttonsHtml + '</div>';
    html += '</div></div></div>';

    $('.app-body').append(html)
        .off('hidden.bs.modal').on('hidden.bs.modal', '.modal', function () {
            $(this).remove();
        })
        .off('shown.bs.modal').on('shown.bs.modal', function () {
            var selector = $('#' + idDlg).find('.button-escape').eq(0);
            $(selector).focus();
        });

    $('#' + idDlg).find('button').off('click').click(function (e) {
        e.preventDefault();

        $('#' + idDlg).find('button').off('click');

        if ($(this).hasClass('button-action-yes')) {
            callback.call(this, true);
        } else if ($(this).hasClass('button-action-no')) {
            callback.call(this, false);
        } else {
            callback.call(this, null);
        }
    });

    $('#' + idDlg).modal({ backdrop: "static", keyboard: true });

}


(function ($) {

    //Add info to input header in Declaration in progress
    $('#formUploadData .description-label').text("Insert file");
    $('#formUploadDispatches .description-label').text("Insert file");
    $('#formUploadInvoices .description-label').text("Insert invoices files");

    if ($('#formUploadData .list_file_uploaded_form').length > 0) {
        $('#formUploadData .description-label').text("Replace file");
    }

    if ($('#formUploadDispatches .list_file_uploaded_form').length > 0) {
        $('#formUploadDispatches .description-label').text("Replace file");
    }

    if ($('#formUploadInvoices .list_file_uploaded_form').length > 0) {
        $('#formUploadInvoices .description-label').text("Insert additional invoices");
    }

    //-----------------
    //no data for this period
    if ($('#nodataforthisperiod:checked').length) {
        $(".widget-file-generic input").prop('disabled', true);
        $(".widget-file-generic").css('opacity', '0.3');
    }


    //
    $(document).ready(function () {
        if ($('body .dip').length) {
            var decid = $('body .dip').attr('dec_id');
            localStorage.setItem('topFixed', decid);
        }
    });

     $(document).ready(function () {
        // TOP FIX
        var pathname = window.location.pathname;
        if (pathname == "/declarations.in_progress/list") {
            var dec_id = localStorage.getItem('topFixed');
            $('tr[id=' + dec_id + ']').addClass('selected');
            //$('tbody').prepend($('tr[id=\"' + dec_id + '\"]'));
            localStorage.removeItem('topFixed');
        }

    });


    /**
    * Verify that the remove button was clicked
    * */
    $(document).on('click', '.btn-declaration-remove', function (e) {
        var aux = $(this);

        if ($(this).hasClass('btn-validate_remove_file')) {
            confirmBox('Are you sure that you want to delete a file ? \n' + 'This will permanently delete the file.', function (result) {
                if (result === true) {
                    //console.log(e);
                    aux.find('a.btn-remove').trigger(e);
                }
            });
        }
    });



})(jQuery);


$(document).ajaxComplete(function() {
    datatables_filters_hide();
});

$(document).ready(function() {
    datatables_filters_hide();
});

$(window).resize(function() {
    datatables_filters_hide();
});

$(window).on( "orientationchange", function( event ) {
    //location.reload(true);
});

